import {
  ClickableSubtitle,
  Contact,
  ContactSubtitle,
} from '@rumblefish/ui/Rumblefish23Theme';
import { contactFormId } from '../const';

const SubtitleComponent = () => (
  <>
    <ContactSubtitle
      variant="regular_500"
      width={{ xs: '100%', md: '55%', xl: '75%' }}>
      Ready to build privacy-preserving systems that your users will actually
      trust?
      <br />
      Let's talk about your requirements and how zero-knowledge proofs can solve
      your specific challenges.
    </ContactSubtitle>

    <ContactSubtitle variant="regular_300">
      Fill out the form or schedule an introductory call now:
      <br />
      <ClickableSubtitle
        color="teal"
        link={'https://bit.ly/rf-sylwia-meeting'}
        target="_blank"
        rel="noopener noreferrer">
        Yes, let's set up a meeting!
      </ClickableSubtitle>
    </ContactSubtitle>
  </>
);

export const ContactZKPD = () => {
  return (
    <Contact
      id={contactFormId}
      color="teal"
      title="Start Your ZK Project Today"
      subtitleComponent={<SubtitleComponent />}
    />
  );
};
